import { visitorInfo } from "@/api/member";
import { launchConsultation } from "@/api/my";
import { getCSBase } from "@/utils/service";
import useNavigation from "@/utils/useNavigate";
import Cookie from "js-cookie";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { btn_click } from "../../track";
import styles from "./index.module.less";

const menuList = [
  // {
  //   type: "coupon",
  //   icon: "https://akim-oss.aikucun.com/30f810e77bd109a7d8d2bea0177e17af727e9d58_1701941469648_54.png",
  //   text: "我的优惠券",
  //   path: "/#/coupon",
  //   show: true,
  // },
  {
    type: "hope",
    icon: "https://akim-oss.aikucun.com/6a3b5ad9e9d5b358ee472f9f7a26c6335f8e56ad_1701941508456_62.png",
    text: "品牌关注",
    path: "/#/my-focus",
    show: true,
  },
  {
    type: "follow",
    icon: "https://akim-oss.aikucun.com/8114ed65ffe915616358db7674e087ef472820b4_1754635155203_35.png",
    text: "商品收藏",
    path: "/mx-shop-micro/follow-product",
    show: true,
  },
  {
    type: "reward",
    icon: "https://akim-oss.aikucun.com/7ecdb0499aefc40bf0f3b4e887537eb68c42b997_1762247414446_39.png",
    text: "中奖记录",
    path: "/mx-shop-micro/reward",
    show: true,
  },
  {
    type: "address",
    icon: "https://akim-oss.aikucun.com/8114ed65ffe915616358db7674e087ef472820b4_1701941546438_43.png",
    text: "收货地址",
    path: "/#/addressList",
    show: true,
  },
  {
    type: "service",
    icon: "https://akim-oss.aikucun.com/310a3dae82417c86a5d149f4674a434488a3a575_1701941621196_93.png",
    text: "联系客服",
    path: "/cschat/chatlist",
    isTrigger: true,
    show: true,
  },
  // {
  //   type: "feedback",
  //   icon: "https://akim-oss.aikucun.com/38a80481bf2c1772fab0d1f35fd7f815a6685387_1701941587924_10.png",
  //   text: "意见反馈",
  //   path: "suggestion",
  //   isTrigger: true,
  //   show: true
  // },
  {
    type: "setting",
    icon: "https://akim-oss.aikucun.com/1a5872b67322ef7be5af6ebc0263257d09bc686b_1702352886888_69.png",
    text: "设置",
    path: "/mx-shop-micro/setting",
    show: true,
  },
  // {
  //   type: "track",
  //   icon: "https://akim-oss.aikucun.com/3fec9e79ca74c88cc5b6357b18f132d8e604e071_1711002570692_60.png",
  //   text: "足迹",
  //   path: "/mx-shop-micro/track",
  // },
];

const Menu: React.FC = () => {
  const { navigate2H5 } = useNavigation();
  const [searchParams] = useSearchParams();
  const shopId = searchParams.get("shopId");
  const distributorId = searchParams.get("distributorId") || "";
  const jumpToCS = async queryObj => {
    const webChannel = 3;
    const query = {
      ...queryObj,
      webChannel,
      shopId,
      distributorId,
    };
    const queryStr = Object.keys(query).reduce((res, i) => `${res}${i}=${query[i]}&`, "?");
    const auditChannel = 2;
    let sourceQueryStr = `shopId=${shopId}&source=3&auditChannel=${auditChannel}&distributorId=${distributorId}`;
    const msUserCode = Cookie.get("msUserCode");
    if (msUserCode) {
      sourceQueryStr += `&userId=${msUserCode}`;
    }
    const base = await getCSBase({
      webChannel,
      locationType: queryObj.locationType,
      merchantCode: queryObj.merchantCode,
    });
    navigate2H5(
      `${base}${queryStr}sourceOrigin=${window.encodeURIComponent(
        window.location.origin,
      )}&sourceQueryStr=${window.encodeURIComponent(sourceQueryStr)}`,
    );
  };
  const checkLocationType = async () => {
    const query = { locationType: 6 };
    const queryObj: any = { locationType: 6 };
    const res: any = await launchConsultation(query);
    if (res && res.success && res.data) {
      const { merchantCode } = res.data;
      if (merchantCode) {
        queryObj.merchantCode = merchantCode;
      }
      jumpToCS(queryObj);
    }
  };

  const toCS = async () => {
    // 是否绑定过
    const res = await visitorInfo();
    if (res) {
      const { isAuthorized, visitorStatus } = res;
      if (isAuthorized !== true || visitorStatus !== 0) {
        navigate2H5("/#/my", { query: "showLoginPopup=1" });
        return;
      } else {
        checkLocationType();
      }
    }
  };
  const goPage = (path: string, type: string, text: string) => {
    if (type === "service") {
      // window.location.href = path;
      toCS();
      btn_click("我的-其他功能设置", text);
      return;
    }
    navigate2H5(path);
    btn_click("我的-其他功能设置", text);
  };
  return (
    <div className={styles["menu"]}>
      {menuList.map((item, index) => (
        <div
          className={styles["menu-item"]}
          key={index}
          onClick={() => goPage(item.path, item.type, item.text)}>
          <img className={styles["menu-item-icon"]} src={item.icon} />
          <div className={styles["menu-item-text"]}>{item.text}</div>
        </div>
      ))}
    </div>
  );
};
export default Menu;
